module.exports = __webpack_public_path__ + "static/media/logo.fc3562cd.png";